import { Component } from '@angular/core';
import { PRESET_REPORT_IDS, PRESET_REPORT_LABELS } from './report-preset.model';
import { MatSelectChange } from '@angular/material';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';


interface Report {
  value: string;
  viewValue: string;
}

interface ReportGroup {
  disabled?: boolean;
  name: string;
  reports: Report[];
}

@Component({
  selector: 'cm-report-presets',
  templateUrl: './report-presets.component.html',
})
export class ReportPresetsComponent {

  reportGroups: ReportGroup[] = [
    {
      name: 'Adops',
      reports: [
        {value: PRESET_REPORT_IDS.adopsReadyToActive, viewValue: PRESET_REPORT_LABELS.adopsReadyToActive},
        // {value: PRESET_REPORT_IDS.adopsDemandPartnerInactivity, viewValue: PRESET_REPORT_LABELS.adopsDemandPartnerInactivity},
        {value: PRESET_REPORT_IDS.adopsTop25missingAdsTxt, viewValue: PRESET_REPORT_LABELS.adopsTop25missingAdsTxt},
        {value: PRESET_REPORT_IDS.unitReview, viewValue: PRESET_REPORT_LABELS.unitReview},
        {value: PRESET_REPORT_IDS.impressionsByDay, viewValue: PRESET_REPORT_LABELS.impressionsByDay},
        {value: PRESET_REPORT_IDS.winRate, viewValue: PRESET_REPORT_LABELS.winRate},
        {value: PRESET_REPORT_IDS.adopsVideoUnits, viewValue: PRESET_REPORT_LABELS.adopsVideoUnits},
      ]
    },
    {
      name: 'Revops',
      reports: [
        {value: PRESET_REPORT_IDS.revopsNegativeProfitabilityUnits, viewValue: PRESET_REPORT_LABELS.revopsNegativeProfitabilityUnits},
        {value: PRESET_REPORT_IDS.revopsNegativeMarginUnits, viewValue: PRESET_REPORT_LABELS.revopsNegativeMarginUnits},
        {value: PRESET_REPORT_IDS.revopsBidderUnits, viewValue: PRESET_REPORT_LABELS.revopsBidderUnits},
        {value: PRESET_REPORT_IDS.revopsEbdaUnits, viewValue: PRESET_REPORT_LABELS.revopsEbdaUnits},
      ]
    },
    {
      name: 'Other',
      reports: [
        {value: PRESET_REPORT_IDS.dpUnitLandscape, viewValue: PRESET_REPORT_LABELS.dpUnitLandscape},
      ]
    }
  ];

  chosenReport: string;

  public constructor(private router: Router, private snapshot: ActivatedRoute) {
    // console.error(this.snapshot.);
    // this.chosenReport = this.snapshot.url;
  }

  onReportChosen(e: MatSelectChange) {
    if(e.value){
      this.router.navigate(['./reports/presets/' + e.value]);
    }
  }

}
